import type { FC } from "react";
import { memo } from "react";
import { ButtonProps } from "./button.types";
import { ButtonInner, StyledButton } from "./button.styles";

export const Button: FC<ButtonProps> = memo(
  ({ text, type, onClick, width, icon, borderradius, disabled, variant }) => {
    return (
      <StyledButton
        text={text}
        type={type}
        variant={variant}
        onClick={onClick}
        width={width}
        disabled={disabled}
        borderradius={borderradius}
      >
        <ButtonInner>
          {icon}
          {text}
        </ButtonInner>
      </StyledButton>
    );
  }
);
